export default "__VITE_ASSET__DScY05R$__"